/**
 * React Router v7 Configuration
 *
 * Defines all routes for the application using React Router v7.
 * Routes use "proposal" terminology, but call "quotation" API endpoints.
 */

import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import RootLayout from './routes/_layout'
import HomePage from './routes/index'
import NewProposalPage from './routes/proposal/new'
import ReviewProposalPage from './routes/proposal/review'
import ProposalsListPage from './routes/proposals/index'
import ProposalDetailPage from './routes/proposals/$id'

/**
 * Main router configuration
 */
export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <HomePage />
      },
      {
        path: 'proposal',
        children: [
          {
            path: 'new',
            element: <NewProposalPage />
          },
          {
            path: 'review',
            element: <ReviewProposalPage />
          }
        ]
      },
      {
        path: 'proposals',
        children: [
          {
            index: true,
            element: <ProposalsListPage />
          },
          {
            path: ':id',
            element: <ProposalDetailPage />
          }
        ]
      }
    ]
  }
])

/**
 * Router Provider Component
 */
export function AppRouter() {
  return <RouterProvider router={router} />
}
